
<template>
  <div>
    <!--查询表单-->
    <el-form>
      <div class="filters-wrap clearfix">
        <div class="filters-action">
          <el-button type="primary" size="small" @click="query">搜索</el-button>
          <el-button size="small" @click="clearSearchForm(params)">清空</el-button>
        </div>
        <div class="filters-area">
          <el-row>
            <el-col :span="7">
              <el-form-item label="所属组织">
                <el-input :maxlength="100" v-model="params.queryParamList[0].value" placeholder="全模糊"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="用户名">
                <el-input :maxlength="100" v-model="params.queryParamList[1].value" placeholder="全模糊"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="7">
              <el-form-item label="姓名">
                <el-input :maxlength="100" v-model="params.queryParamList[2].value" placeholder="全模糊"></el-input>
              </el-form-item>
            </el-col>
          </el-row>
        </div>
      </div>
    </el-form>
    <div class="page-grid">
      <egrid class="egrid" auto-height="500" stripe fit border highlight-current-row  v-loading="loading" element-loading-text="正在努力加载中..." :column-type="['selection', 'index']"
             :data="tableData" :columns="columns" :columns-schema="columnsSchema" @selection-change="checkIds"  @row-dblclick="dobluClick" ref="eltable">
      </egrid>
      <epagination :total="total" :current="currentPage" @change="getPages" :page-sizes="[25,50,100,200]" v-if="tableData"></epagination>
      <div>
      </div>
    </div>
    <!--操作按钮-->
    <span class="parent-dialog-footer">
          <el-button @click="cancel">关 闭</el-button>
          <el-button type="primary" @click="updateParent">添 加</el-button>
      </span>
  </div>

</template>
<script>
  import listMixins from '@/mixins/list'

  export default {
    mixins:[listMixins],
    name:'DelegationPerson',
    props:['row','type'],
    data(){
      return{
        // 以下为table相关
        params: {
          page: 1,
          pageSize: this.$cache.getConfig("list_page_default_pagesize"),
          orderBy: "id desc",
          totalRows: 0,
          export: false,
          queryParamList: [
            {field: "orgName",type: "string" ,logic: "like" , value:'',items: []},
            {field: "userName",type: "string" ,logic: "like" , value:'',items: []},
            {field: "name",type: "string" ,logic: "like" , value:'',items: []},
          ]
        },
        columns:[
          { label: '用户名',  prop: 'userName', align: 'center', width: 'auto',  sortable: true, },
          { label: '姓名',  prop: 'name', align: 'center', width: 'auto',  sortable: true, },
          { label: '所属组织',  prop: 'orgName', align: 'center',width: 'auto', sortable: true, },
          { label: '邮箱',   prop: 'email',width: 'auto', align: 'center', sortable: true, },
          { label: '电话',  prop: 'phone',width: 'auto' ,align: 'center', sortable: true, },
        ],
        columnsSchema:{},

      }
    },
    methods:{
      // 清空表单
      clearSearchForm(params,current){
        if(params.queryParamList){
          for(let i = 0;i<params.queryParamList.length;i++){
            params.queryParamList[i].value=''
            params.queryParamList[i].items=[]
          }
        }
        this.query()
      },
      updateParent(){
        if(this.checkedList.length!=1){
          this.$message.error("请选择一行数据")
          return
        }
        this.$emit('change',this.checkedList,'delegation')
      },
      cancel(){
        this.$emit('cancel')
      },
      dobluClick(row,event){
        this.$refs.eltable.toggleRowSelection(row);
      },
    },
    mounted() {
      console.log('mounted delegation',this.row)
      this.initTableData(this.$api.workflow_Authorized.queryPerson, this.params)
    },
  }

</script>
<!--<style scoped>
  .parent-dialog-footer{
    position: absolute;
    right: 5%;
    bottom: 3%;
    z-index: 999;
  }
</style>-->
